import { ElemPlaceholderReasonType } from '@goodt-wcore/elem';
import { DATASET_PANEL_ID } from './consts';

/**
 *
 * @type {import('@goodt-wcore/elem').ElemPlaceholderDescriptor}
 */
export const ElemDatasetPlaceholderDefinition = {
    show: true,
    toggle: true,
    content: 'Добавьте источник данных',
    reason: {
        type: ElemPlaceholderReasonType.DATA_SOURCE,
        actions: [{ title: 'Добавить источник', icon: 'plus', panel: DATASET_PANEL_ID }]
    }
};
